import { AnyARecord } from "dns";
import { RouteParams } from "@app/helpers";
import { Timezone } from "./organization.model";
import { SuveryDetailTable } from "./survey.model";
import { SelectorUserData, SelfCareGiverData } from "./user.model";
import { PortalUserListItem } from "./profile.model";

export interface GeneralListDataResponse<T> {
  message: string;
  data: {
      count: number;
      rows: T[];
      profileIds?: any[];
  }
  page: number;
  limit: number;
}
export interface DialogData {
  message: string;
  messageSegments?: Array<{ text: string; bold?: boolean }>;
  list?: string[];
  listStyles?: string;
  title: string;
  actions: { cancel: string, ok: string };
  actionColor?: { cancel: string; ok?: string; };
  enableClose?: boolean;
  buttonContainerClass?: string;
  actionTypes?: { cancel?: string; ok?: string; };
  footerMessage?: string;
}

export class TimeData {
  label: string;
  hours: number;
  minutes: number;

  constructor(label?: string, hours?: number, minutes?: number) {
    this.label = label || '';
    this.hours = hours || 0;
    this.minutes = minutes || 0;
  }
}

export interface OrganizationFilter {
  seniorCenters: SeniorCenterFilter[];
  id: number;
  name: string;
  checkAll: boolean; // not a part of api
  checked: boolean; // not a part of api
}

export interface SeniorCenterFilter {
  id: number;
  name: string;
  checked: boolean; // not a part of api
}

export interface AppStatus {
  status: string;
  message: string;
  showNote?: boolean;
}

export interface FilterData { 
  name: string; 
  key: string; 
  checked: boolean; 
  value: boolean | 0 
};

export interface RouteEventData { 
  eventName: string;
  pageTitle: string;
  screenName: string;
};

export interface UserListFilters {
  language: FilterCheck[];
  gender: FilterCheck[];
  active: FilterCheck[];
}
export interface BroadcastHistoryFilters {
  language: FilterCheck[];
  type: FilterCheck[];
}
export interface BroadcastListFilters {
  language: FilterCheck[];
}

export interface FilterCheck {
  label: string;
  value: string;
  checked: boolean;
}
export interface UserSelectorData {
  selectedUsers: SelectorUserData[];  // list of users in checkbox list
  confirmedUsers: SelectorUserData[]; // list of users checked in checkbox list
  isRadioCheck?: boolean;
}
export interface UserSelectorPanelNotes {
  noSelectedNote?: string;
  tableInitialText?: string;
}

export interface ConstData {
  values: string[];
}
export interface RequestProgressData {
  title: string;
  message: string; 
  progressBarOptions: { 
    mode: 'determinate' | 'indeterminate', 
    color: 'primary' | 'accent' | 'warn', 
    value?: number;
  };
  actionLink?: { label: string; link: string };
}
export interface CustomSearchBarConfig {
  selectedSearchByOptions?: {
    name: string;
    value: string;
    placeholder?: string;
  },
  searchByOptions?: {
    name: string;
    value: string;
    placeholder?: string;
  }[];
  input: {
    value: string;
    placeholder: string;
  };  
  searchBtn?: {icon: string; iconClass: string};
  resetBtn?: {icon: string; iconClass: string};
}
export interface CustomSelectorValue<T> {
  name: string;
  value: T;
}

//Scheduler Fields component
export interface ScheduleData {
  date: moment.Moment;
  time: TimeData | undefined;
}

export interface MultiSchedulerData {
  title: string;
  tooltip: string;
  description: string;
  createBtnLabel: string;
  tableHeaderLabels: string[]
  values: {
    createdBy: string; 
    value: string; 
    status: {
      class:string;
      value:string;
    } | null; 
    disabled?: boolean;
  }[];
  userMail?: string; // Current user email address to show newly created record
  minScheduleTime?: string; // Minimum scheduling time to validate
  formData: {
    title: string;
    description: string;
    labels: string[];
    buttons: string[];
  };
  warnNote?: string;
}

export class ConvertSelfCareGiverData {
  value: SelfCareGiverData = null;

  constructor(value: any) {
    if (typeof(value) == 'string' && value.includes("'")) {
      value = value.replace(/'/g, "");
    }
    switch (value) {
      case 'Yes':
        this.value = 'Yes';
        break;
      case 'No':
        this.value = 'No';
        break;
      case 'Unsure':
        this.value = 'Unsure';
        break;

      default:
        this.value = null;
        break;
    }
  }
}

/**TABLE FILTER COMPONENT */
export interface TableFilterDataOption {
  label: string;
  value: string;
  checked: boolean;
}
export class TableFilterData {
  label: string;
  value: string;
  options: TableFilterDataOption[];
  multiSelect: boolean;
  showLabelWithSelected?: boolean;
  
  constructor(
      label: string, 
      value: string, 
      options: TableFilterDataOption[], 
      multiSelect: boolean = false, 
      showLabelWithSelected?: boolean
  ) {
      this.label = label;
      this.value = value;
      this.options = options;
      this.multiSelect = multiSelect;
      this.showLabelWithSelected = showLabelWithSelected;
  }
  
}
/** PREVIEW SHEET */
export interface PreviewSheetData {
  title: string;
  subtitle?: string;
  infoTooltip?: string;
  warnMessage?: {value: string; isErrorType?: boolean; list?: string[]; buttonMessage?: string, data?: any, name?: string}[];
  previewData: SuveryDetailTable;
  actionL?: {value: string; disabled?: boolean;};
  actionR?: {value: string; disabled?: boolean;};
  timezone?: Timezone;
  pageName?: string;
}
export interface DuplicateCommRecord {
  id: string;
  run_id: string;
  message: string;
  comm_status: string;
  name: string;
  org_id: number;
  senior_centers: string;
  comm_type: string;
  schedule_time: string;
  sent_date: string;
  createdAt: string;
}

export interface TagSelectorData {
  title: string;
  tooltip: string;
  description: string;
  createBtnLabel: string;
  values: number[];
  availableTags:  TagData[];
  formData: {
    title: string;
    description: string;
    buttons: string[];
  };
  warnNote?: string;
}
export interface NavLinksGroup {
  navs: CustomNavLink[];
  admin: CustomNavLink[];
  system: CustomNavLink[];
}

export interface CustomNavLink {
  route:  string[];
  label:  string;
  icon:  string;
  featureName: string;
  iconSymbol?: boolean;
  exactActiveCheck?: boolean;
  anchorClass?: string;
  subRoutes?: {
    route:  string[];
    label:  string;
    featureName: string;
    linkActiveCheck?: string;
  }[];
}
export interface PreviewStartDatePayload {
  date: { rowNumber: string; commDate: string; }[];
  offset: string;
  timezone_identifier?: string;
  timezone_name: string;
}
export interface TagData {
  id: number;
  name: string;
}

export interface CreateTagData {
  name: string;
}

export interface CustomTableData<T> {
  listData: GeneralListDataResponse<T> | null;
  dataColumns: CustomTableColumns[];
  filtersData: TableFilterData[];
  filtersKeyOrder: string[];
  searchBarConfig: CustomSearchBarConfig;
  filterParams: RouteParams;
}
export interface CustomTableListInfos {
  noRecordTitle: string;
  noRecordDesc: string;
  noRecordLengthTitle: string;
  noRecordLengthDesc: string;
}

export interface CustomTableColumns {
  name: string;
  value: string;
  hasSort?: boolean;
  headerClasses?: string;
  descriptionClasses?: string;
  contentType?: 'text' | 'status';
}

export interface MailRecipientSelectorData {
  title: string;
  tooltip: string;
  description: string;
  createBtnLabel: string;
  values: number[];
  availableRecipients: PortalUserListItem[];
  formData: {
    title: string;
    description: string;
    buttons: string[];
  };
  warnNote?: string;
}

export interface ServiceDownBannerData {
  service_name: string;
  is_service_down: boolean;
  message: string;
  created_at: string;
}

export interface AccountLimitsData {
  plan: string;
  limits: AccountFeatureLimitsData[];
}

export interface AccountFeatureLimitsData {
  [k:string]: AcLimitData;
  // plan?: string;
}
export interface AcLimitData { 
  count: number;
  limit: number; 
  is_on_limit: boolean; 
  name?: string;
  left: number;
}

export interface InterestAssociateWarnDialogModel {
  title: string;
  subtitle: string;
  tableCols: string[];
  tableColumns: {
      name: string;
      value: string;
      class?: string;
  }[];
  tableData: any[];
};

export interface OrgLabelsFilter {
  organizationLabels: OrgLabels[];
  id: number;
  name: string;
  checkAll: boolean; // not a part of api
  checked: boolean; // not a part of api
}

export interface OrgLabels {
  id: number;
  name: string;
  checked: boolean; // not a part of api
}

export interface CustomFieldFilter {
  checkAll: boolean;
  options: Array<{
    name: string;
    key: string;
    field_id: number;
    field_type: string;
    checked: boolean;
    values?: Array<{
      id: number; 
      value: string;
      checked: boolean;
    }>;
  }>;
}

export interface CustomQuillMention {
  id: string;
  value: string;
}

export interface CustomCalendarDateRange {
  start: moment.Moment;
  end: moment.Moment;
}

export interface CustomCalendarDateRangeOption {
  label: string;
  value: string;
}

export enum DateRangeValues {
  month = 'month',
  lastMonth = 'lastMonth',
  thisWeek = 'thisWeek',
  lastWeek = 'lastWeek',
  last30Days = 'last30Days',
  allTime = 'allTime'
}